import {http,BaseUtil} from '@zkwq/business'
import {CACHE_KEY} from '../constants'

const SetStorage = BaseUtil.setStorage;
const GetStorage = BaseUtil.getStorage;
const RemoveStorage = BaseUtil.removeStorage;

let appid = '';
let secret = '';
let redirectUri = '';
let quitRedirectUri = '';
if(process.env.NODE_ENV == 'development'){
    appid = 'hkyjx306hejunbgjad';
    secret = 'autwhtmov6mbm5en5mzmbnhde6ar9g7d';
    redirectUri = 'http://localhost:8080';
    quitRedirectUri = 'http://localhost:8080';
}else{
    appid = 'hkyjx306hejunbgjac';
    secret = 'autwhtmov6mbm5en5mzmbnhde6ar9g7p';
    // redirectUri = 'http://124.16.154.217:8081/loadLogin';
    // quitRedirectUri = 'http://124.16.154.217:8081';
    redirectUri = 'https://ir.scholarin.cn/';
    quitRedirectUri = 'https://ir.scholarin.cn/';
}

export const loginUrl = `https://scholarin.cn/oauth/authorize?appid=${appid}&redirect_uri=${redirectUri}&scope=api_signin&response_type=code&state=STATE`

export const getAccessToken = (code,callBack) => {
    if(code){
        http.get(`https://scholarin.cn/hky/oauth/access_token?appid=${appid}&secret=${secret}&code=${code}&grant_type=authorization_code`).then(resp => {
            if(resp.failure){
                alert('登录失败,请重试')
                location.href = '/'
            }else{
                getUserInfo(resp.user_id,callBack);
            }
        }).catch(e => {
            console.error(e)
        })
    }
}
export const getUserInfo = (userId,callBack) => {
    http.get(`/hky/api/v2/scholars/${userId}`).then(e => {
        callBack && callBack(e)
    }).catch(e => {
        console.error(e)
    });
}

export const toLogin = (url) => {
    let showurl = location.href;
    if (url) {
        showurl = url;
    }
    SetStorage(CACHE_KEY.TARGET_PATH,showurl)
    location.href = loginUrl
}

export const outLogin = () => {
    RemoveStorage(CACHE_KEY.TARGET_PATH)
    var url = encodeURIComponent(`https://scholarin.cn/hky/oauth/logout?appid=${appid}&redirect_uri=${quitRedirectUri}`);
    location.href = `https://passport.escience.cn/logout?WebServerURL=${url}`
}

function getUrlParam(str, def) {
    var query = window.location.search.substring(1);
    query = decodeURIComponent(query);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == str) { return pair[1]; }
    }
    return def || '';
}